module.exports = __webpack_public_path__ + "img/j.a4caa68e.jpg";